// The small number box most of a section's extra rows use (counts, minutes,
// rates), as a call so a row reads like the template: 4 × 30 min.
import { NumberField } from './number-field';

export const small = (value: number | null | undefined, onChange: (v: number | null) => void, label: string) => (
  <NumberField compact value={value} placeholder="0" onChange={onChange} label={label} className="w-14" />
);
